import React, { Component } from 'react';
import { translate } from 'react-i18next';
import { esimApi } from './esimApi';
import QRCode from "react-qr-code";

class ESIMSetup extends Component {
    copyResetTimer = null;

    state = {
        selectedCountry: this.props.location.state?.selectedCountry || {
            name: '',
            flag: ''
        },
        selectedPlan: this.props.location.state?.selectedPlan || {
            volume: ''
        },
        instructions: null,
        isLoading: false,
        activeMethod: 'qr',
        qrInstructions: {
            title: 'QR kodu skan edin',
            description: 'Open your camera app and scan the QR code to begin installation. Requires iOS 16+ or Android 10+.'
        },
        qrPayload: '',
        manualSetup: {
            smdpAddress: '',
            activationCode: '',
            steps: []
        },
        helpInfo: {
            title: 'Toplu köçürmələr necə edilir?',
            description: 'Ölkədaxili köçürmə zamanı vəsaiti alan tərəfin hesabı respublika daxilində istənilən bankda mövcud ola bilər. Vəsaiti alan şəxsın bank seçilir və alan şəxsın'
        },
        copiedField: null
    }

    setMethod = (activeMethod) => {
        this.setState({ activeMethod });
    }

    componentDidMount = () => {
        this.loadInstructions();
    }

    componentWillUnmount() {
        if (this.copyResetTimer) {
            clearTimeout(this.copyResetTimer);
        }
    }

    loadInstructions = async () => {
        const esimId = this.props.match.params.planId || this.state.selectedPlan.id;

        if (!esimId) {
            return;
        }

        this.setState({ isLoading: true });

        try {
            const response = await esimApi.getInstructions(esimId);
            this.setState({
                instructions: response,
                activeMethod: response?.data?.defaultMethod === 'manual' || response?.defaultMethod === 'manual' ? 'manual' : 'qr',
                qrInstructions: {
                    title: response?.data?.qr?.title || response?.qr?.title || 'QR kodu skan edin',
                    description: response?.data?.qr?.description || response?.qr?.description || 'Open your camera app and scan the QR code to begin installation. Requires iOS 16+ or Android 10+.'
                },
                qrPayload: response?.data?.qrPayload || response?.qrPayload || '',
                manualSetup: {
                    smdpAddress: response?.data?.smdpAddress || response?.smdpAddress || '',
                    activationCode: response?.data?.activationCode || response?.activationCode || '',
                    steps: response?.data?.steps || response?.manual?.steps || []
                },
                isLoading: false
            });
        } catch (error) {
            this.setState({ isLoading: false });
        }
    }

    copyText = async (text, field) => {
        try {
            if (navigator?.clipboard?.writeText) {
                await navigator.clipboard.writeText(text);
            }

            if (this.copyResetTimer) {
                clearTimeout(this.copyResetTimer);
            }

            this.setState({ copiedField: field });
            this.copyResetTimer = setTimeout(() => {
                this.setState({ copiedField: null });
            }, 1000);
        } catch (error) {
            // Ignore clipboard errors for now.
        }
    }

    renderMethodCards = () => {
        const { activeMethod } = this.state;

        return (
            <div className="dashboard-esim-setup-methods">
                <button
                    type="button"
                    className={`dashboard-esim-setup-method-card ${activeMethod === 'qr' ? 'dashboard-esim-setup-method-card__active' : ''}`}
                    onClick={() => this.setMethod('qr')}
                >
                    
                        <svg xmlns="http://www.w3.org/2000/svg" width="44" height="44" viewBox="0 0 44 44" fill="none">
                        <path d="M0 12C0 5.37258 5.37258 0 12 0H32C38.6274 0 44 5.37258 44 12V32C44 38.6274 38.6274 44 32 44H12C5.37258 44 0 38.6274 0 32V12Z" fill="#1D4ED8" fill-opacity="0.07"/>
                        <path d="M17.8333 14.5H15.3333C14.8731 14.5 14.5 14.8731 14.5 15.3333V17.8333C14.5 18.2936 14.8731 18.6667 15.3333 18.6667H17.8333C18.2936 18.6667 18.6667 18.2936 18.6667 17.8333V15.3333C18.6667 14.8731 18.2936 14.5 17.8333 14.5Z" stroke="#1D4ED8" stroke-width="1.66667" stroke-linecap="round" stroke-linejoin="round"/>
                        <path d="M28.6673 14.5H26.1673C25.7071 14.5 25.334 14.8731 25.334 15.3333V17.8333C25.334 18.2936 25.7071 18.6667 26.1673 18.6667H28.6673C29.1276 18.6667 29.5007 18.2936 29.5007 17.8333V15.3333C29.5007 14.8731 29.1276 14.5 28.6673 14.5Z" stroke="#1D4ED8" stroke-width="1.66667" stroke-linecap="round" stroke-linejoin="round"/>
                        <path d="M17.8333 25.3333H15.3333C14.8731 25.3333 14.5 25.7063 14.5 26.1666V28.6666C14.5 29.1268 14.8731 29.4999 15.3333 29.4999H17.8333C18.2936 29.4999 18.6667 29.1268 18.6667 28.6666V26.1666C18.6667 25.7063 18.2936 25.3333 17.8333 25.3333Z" stroke="#1D4ED8" stroke-width="1.66667" stroke-linecap="round" stroke-linejoin="round"/>
                        <path d="M29.5007 25.3333H27.0007C26.5586 25.3333 26.1347 25.5088 25.8221 25.8214C25.5096 26.134 25.334 26.5579 25.334 26.9999V29.4999" stroke="#1D4ED8" stroke-width="1.66667" stroke-linecap="round" stroke-linejoin="round"/>
                        <path d="M29.5 29.5V29.5083" stroke="#1D4ED8" stroke-width="1.66667" stroke-linecap="round" stroke-linejoin="round"/>
                        <path d="M22.0007 17.8333V20.3333C22.0007 20.7753 21.8251 21.1992 21.5125 21.5118C21.1999 21.8243 20.776 21.9999 20.334 21.9999H17.834" stroke="#1D4ED8" stroke-width="1.66667" stroke-linecap="round" stroke-linejoin="round"/>
                        <path d="M14.5 22H14.5083" stroke="#1D4ED8" stroke-width="1.66667" stroke-linecap="round" stroke-linejoin="round"/>
                        <path d="M22 14.5H22.0083" stroke="#1D4ED8" stroke-width="1.66667" stroke-linecap="round" stroke-linejoin="round"/>
                        <path d="M22 25.3333V25.3416" stroke="#1D4ED8" stroke-width="1.66667" stroke-linecap="round" stroke-linejoin="round"/>
                        <path d="M25.334 22H26.1673" stroke="#1D4ED8" stroke-width="1.66667" stroke-linecap="round" stroke-linejoin="round"/>
                        <path d="M29.5 22V22.0083" stroke="#1D4ED8" stroke-width="1.66667" stroke-linecap="round" stroke-linejoin="round"/>
                        <path d="M22 29.5001V28.6667" stroke="#1D4ED8" stroke-width="1.66667" stroke-linecap="round" stroke-linejoin="round"/>
                        </svg>
                    <h4>{this.props.t('QR Code')}</h4>
                    <p>{this.props.t('Scan a QR code using your camera to install your eSIM on this device.')}</p>
                </button>

                <button
                    type="button"
                    className={`dashboard-esim-setup-method-card ${activeMethod === 'manual' ? 'dashboard-esim-setup-method-card__active' : ''}`}
                    onClick={() => this.setMethod('manual')}
                >
                    <svg xmlns="http://www.w3.org/2000/svg" width="44" height="44" viewBox="0 0 44 44" fill="none">
                    <path d="M0 12C0 5.37258 5.37258 0 12 0H32C38.6274 0 44 5.37258 44 12V32C44 38.6274 38.6274 44 32 44H12C5.37258 44 0 38.6274 0 32V12Z" fill="#1D4ED8" fill-opacity="0.07"/>
                    <path d="M26.166 13.6667H17.8327C16.9122 13.6667 16.166 14.4129 16.166 15.3334V28.6667C16.166 29.5872 16.9122 30.3334 17.8327 30.3334H26.166C27.0865 30.3334 27.8327 29.5872 27.8327 28.6667V15.3334C27.8327 14.4129 27.0865 13.6667 26.166 13.6667Z" stroke="#1D4ED8" stroke-width="1.66667" stroke-linecap="round" stroke-linejoin="round"/>
                    <path d="M22 27H22.0083" stroke="#1D4ED8" stroke-width="1.66667" stroke-linecap="round" stroke-linejoin="round"/>
                    </svg>
                    <h4>{this.props.t('Manual Installation')}</h4>
                    <p>{this.props.t('Enter SM-DP+ Address and Activation Code manually in your device eSIM settings.')}</p>
                </button>
            </div>
        );
    }

    renderQRView = () => {
        const { qrInstructions, qrPayload } = this.state;

        return (
            <div className="dashboard-esim-setup-panel">
                <h5>{qrInstructions.title}</h5>
                <div className="dashboard-esim-setup-qr-wrap">
                    <div className="dashboard-esim-setup-qr-box">
                        {qrPayload ? <QRCode value={qrPayload} size={144} /> : null}
                    </div>
                </div>
                <p>{qrInstructions.description}</p>
            </div>
        );
    }

    renderManualView = () => {
        const { manualSetup, copiedField } = this.state;

        return (
            <div className="dashboard-esim-setup-panel dashboard-esim-setup-panel__manual">
                <div className="dashboard-esim-setup-manual-details">
                    <h5>{this.props.t('Quraşdırılma detalları')}</h5>

                    <div className="dashboard-esim-setup-detail-item">
                        <span>SM-DP+ ADDRESS</span>
                        <strong>{manualSetup.smdpAddress}</strong>
                        <button type="button" onClick={() => this.copyText(manualSetup.smdpAddress, 'smdpAddress')}>
                            {copiedField === 'smdpAddress' ? `✓ ${this.props.t('Kopyalandı')}` : this.props.t('Kopyala')}
                        </button>
                    </div>

                    <div className="dashboard-esim-setup-detail-item">
                        <span>ACTIVATION CODE</span>
                        <strong>{manualSetup.activationCode}</strong>
                        <button type="button" onClick={() => this.copyText(manualSetup.activationCode, 'activationCode')}>
                            {copiedField === 'activationCode' ? `✓ ${this.props.t('Kopyalandı')}` : this.props.t('Kopyala')}
                        </button>
                    </div>

                    <button type="button" className="dashboard-esim-setup-done-btn" onClick={() => this.props.history.push('/dashboard/services/e-sim/my-esims')}>
                        {this.props.t('Done - Go to My Plans')}
                    </button>
                </div>

                <div className="dashboard-esim-setup-manual-steps">
                    <h5>{this.props.t('Addımlar')}</h5>
                    <ul>
                        {manualSetup.steps.map((step, index) => (
                            <li key={step}>
                                <span>{index + 1}</span>
                                <p>{step}</p>
                            </li>
                        ))}
                    </ul>
                </div>
            </div>
        );
    }

    render() {
        const { activeMethod, helpInfo, isLoading } = this.state;

        return (
            <>
                <div className="dashboard-header-route">
                    <div className="dashboard-header-route-left">
                        <button onClick={() => this.props.history.goBack()}>
                            <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M11.7344 21.2188L12.6719 20.3281C12.9062 20.0938 12.9062 19.7188 12.6719 19.5312L5.40625 12.2188H21.4375C21.7188 12.2188 22 11.9844 22 11.6562V10.3438C22 10.0625 21.7188 9.78125 21.4375 9.78125H5.40625L12.6719 2.51562C12.9062 2.32812 12.9062 1.95312 12.6719 1.71875L11.7344 0.828125C11.5469 0.59375 11.1719 0.59375 10.9375 0.828125L1.14062 10.625C0.90625 10.8594 0.90625 11.1875 1.14062 11.4219L10.9375 21.2188C11.1719 21.4531 11.5469 21.4531 11.7344 21.2188Z" fill="#2E3131" />
                            </svg>
                        </button>
                        <h2>{this.props.t('eSIM')}</h2>
                    </div>
                </div>

                <div className="dashboard-account-body">
                    <div className="m-3" style={{ marginTop: '1px' }}>
                        <div className="dashboard-esim-setup-layout">
                            <div className="dashboard-esim-setup-main">
                                <h3>{this.props.t('Quraşdırılma')} {isLoading ? '...' : ''}</h3>

                                {this.renderMethodCards()}

                                {activeMethod === 'qr' ? this.renderQRView() : this.renderManualView()}
                            </div>

                            {/* <aside className="dashboard-esim-setup-side">
                                <h4>{helpInfo.title}</h4>
                                <div className="dashboard-esim-setup-side-illustration" aria-hidden="true" />
                                <p>{helpInfo.description}</p>
                            </aside> */}
                        </div>
                    </div>
                </div>
            </>
        );
    }
}

export default translate('translation')(ESIMSetup);